import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RUI_CONTROL_ATTR } from "../form/control-protocol";
export function RuiTextarea(props) {
  const {
    class: className,
    rows = 3,
    ...host
  } = props;
  return /* @__PURE__ */jsx("textarea", {
    ...host,
    rows,
    ...{
      [RUI_CONTROL_ATTR]: ""
    },
    "data-rui-control-type": "text",
    class: cx("rui-textarea", className)
  });
}